import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import DatePicker from "react-datepicker"
import MUIDataTable from "mui-datatables";
import Selectsearch from "react-select"


// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';


import {
   allCumulativeReport,
   allStudents, 
} from 'Actions';


import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


class cumulativereport extends Component {
   
   constructor(props) {
      
      super(props);
       
         this.state = {
            student: '',
            checkoutdate:'',
            checkindate:'',
            seldate:new Date(),
               };      
              
               
               this.handleSubmit = this.handleSubmit.bind(this)
   }

   UNSAFE_componentWillMount() {
		this.props.allStudents();  
       this.getreport();
	}

    getreport(){
        var startdate=this.state.checkoutdate;
        var enddate=this.state.checkindate;
        var student=this.state.student;
        this.props.allCumulativeReport(startdate,enddate,student);
    }

    handleSubmit(event)
    {
        event.preventDefault();
        this.getreport()
    }

   

   selectdates = (date) => {
  
      this.setState({ checkoutdate:date });
     
     
  }
  
  selectdatee = (date) => {
           
       this.setState({ checkindate:date });
      
      
  }

  
   
    render() {

       const { match, studentlists,travelreportlist1,loading,} = this.props;
       
       
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };
       
        const allstudent=studentlists.map((stdval) => {  
            
              return {
                label: stdval.student,  
                value: stdval.uudID
            
                
              }
              
        });
    
        const columns = [
            { name: "sno", label: " SNO" },
            { name: "sname", label: "STUDENT NAME" },
            { name: "ttotaldays", label: "TOTAL DAYS OUT" },
            { name: "oncampus", label: "ON CAMPUS" },
            { name: "tournament", label: "TOURNAMENT" },
            { name: "medical", label: "MEDICAL" },
            { name: "personal", label: "PERSONAL" },
            { name: "clubfitting", label: "CLUB FITTING" },
            { name: "acadamics", label: "ACADEMICS" }
        ];
        const tabledata=travelreportlist1.map((assmntval,idx) => {   
                   
                return ( {
                sno:idx+1,
                sname: assmntval.student,
                ttotaldays: assmntval.totaldays,
                oncampus: assmntval.campusdays,
                tournament: assmntval.tournamentdays,
                medical: assmntval.medicaldays,
                personal:assmntval.personaldays,
                clubfitting:assmntval.clubfitdays,
                acadamics:assmntval.academydays,
                })
        });
   

       return (
         
       <div className="saas-dashboard">
         
             <Helmet>
                <title>Travel Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Travel" />
             </Helmet>
             
             <PageTitleBar title={<IntlMessages id="sidebar.cumulativereport" />} match={match} />
             <div className="col-lg-12">             

                   <RctCollapsibleCard heading="Student Travel Report" fullBlock>
                                           
                            <div className="row" style={{padding:"20px"}}>
                                <div className="col-lg-3">
                                        <FormGroup >
                                            <Label for="Email-3">Start Date </Label>
                                            <DatePicker className="form-control" id="checkoutdate"  name="checkoutdate" autoComplete="off" 
                                                    selected={this.state.checkoutdate}
                                                    onChange={this.selectdates}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown 
                                                    
                                                /> 
                                        </FormGroup>                                          
                                </div>

                                    <div className="col-lg-3">
                                        <FormGroup >
                                            <Label for="Email-3">End Date </Label>
                                            <DatePicker className="form-control" id="checkindate"  name="checkindate" autoComplete="off" 
                                                    selected={this.state.checkindate}
                                                    onChange={this.selectdatee}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                /> 
                                        </FormGroup>                                          
                                    </div> 

                                    <div className="col-lg-3">                                           
                                        <Label for="Email-3">Student </Label>
                                        <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.setState({ student: evt.value })} required/>                                            
                                    </div> 

                                    <div className="form-group">                       
                                            <input type="submit" onClick={this.handleSubmit} className="mr-3 mb-3 btn btn-outline-primary" value="Submit" style={{marginTop:"20px"}}/>                                            
                                    </div>  
                                                        
                            </div>
                            
                    </RctCollapsibleCard>

                </div>    
                <div className="col-lg-12">  
                        <MUIDataTable    
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     
                </div>  
                
         </div>
       )

      }
 }

const mapStateToProps = ({cumulativereport,mostlyused, ssteam}) => {
    const { studentlists, } = mostlyused;
	const { travelreportlist1, loading } = cumulativereport;
	return { studentlists,travelreportlist1,loading };
}

export default connect(mapStateToProps,{
    allCumulativeReport,
    allStudents,
  
})(cumulativereport); 